module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/4@2x_34584e33ef203688628dbd153c7769ec.png";